import { Component, Input, inject, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {DocRequest} from "../../../core/invoices/api/doc.request.model";
import {InvoicesRestService} from "../../../core/invoices/services/invoices.rest.service";
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MatTableDataSource, MatTable} from "@angular/material/table";


@Component({
    selector: 'app-invoices-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss'],
    standalone: false
})
export class ResultsComponent implements OnDestroy, OnInit, OnChanges {
  private ngUnsubscribe$ = new Subject<boolean>();
  displayedColumns: string[] = ['invNr', 'type', 'idf', 'invDate', 'download'];
  @Input() documents: any[] = [];
  dataSource = new MatTableDataSource();
  loading = true;
  private invoicesRestService = inject(InvoicesRestService);


  constructor(){
  }

  ngOnInit(){
    if(this.documents.length > 0) {
      this.dataSource.data=this.documents;
      this.loading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;

    if (changes['documents']) {
      if(this.documents.length > 0){
        this.dataSource = new MatTableDataSource(this.documents);
        this.loading = false;
      }
    }
  }



  downloadDocument(document: any, docType: any, $event: Event) {
    $event.preventDefault();
    $event.stopPropagation();

    const xml = document.filename.indexOf('xml') > -1;
    let docRequest = new DocRequest({
      docDate: document.inv_date,
      docNr: document.inv_nr,
      docType: docType.attribute,
      idf: document.idf,
      vz: 21,
      xml: xml
    });
    this.invoicesRestService.getDocument(docRequest);
  }


  /**
   * Unsubscribe from all subscriptions.
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }

}
